module.exports = __webpack_public_path__ + "static/media/identidad_logo.49e4c4f0.png";